export const OPPLOANS = 'opploans';
export const FINWISE = 'finwise';
export const FEB = 'feb';
export const CCB = 'ccb';

export const TURNUP_EVEN = 'even';
export const TURNUP_QUINSTREET = 'quinstreet';
export const TURNUP_ONE_MAIN = 'one_main';

export const BASE_ARB_AGREEMENT_PATH = '/registrations/arbitration_template';

export const REFINANCE_FAQ_URL = 'https://www.opploans.com/faqs/refinance/';

export const ADDRESS_PATTERN = new RegExp(
  /(?:P(?:ost(?:al)?)?[.\-\s]*(?:(?:O(?:ffice)?[.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i
);
/* eslint-disable no-control-regex, no-useless-escape */
export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/* eslint-enable no-control-regex, no-useless-escape */
export const NAME_PATTERN = new RegExp('[#%&{}\\\\<>*?/$!":@+`|=~^()]');
export const PASSWORD_LETTER_PATTERN = /^(?=.*[a-z])(?=.*[A-Z]).+$/;
export const PASSWORD_NUMBER_PATTERN = /^(?=.*\d).+$/;
export const PASSWORD_SPECIAL_CHARS_PATTERN = /^(?=.*[@$!%*#?&\s]).+$/;
export const SSN_PATTERN = new RegExp(
  '^(?!219099999|078051120|457555462)(?!666|000|9\\d{2})\\d{3}(?!00)\\d{2}(?!0{4})\\d{4}$'
);

export const SEMI_MONTHLY = 'twice_per_month';
export const WEEKLY = 'weekly';
export const BIWEEKLY = 'biweekly';
export const MONTHLY = 'monthly';

export const SET_DATA = 'SET_DATA';
export const SET_ERROR = 'SET_ERROR';

export const REQUIRED_ERROR = 'Field is required';

export const VISA = 'Visa';
export const MASTERCARD = 'MasterCard';

export const ACH = 'ach';
export const DEBIT_CARD = 'debit_card';

export const STATES = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY'
];

export const INCOME_SOURCE_OPTIONS = [
  {
    displayValue: 'Employment',
    id: 'primaryIncomeSourceEmployment',
    value: 'employment'
  },
  {
    displayValue: 'Self-Employment',
    id: 'primaryIncomeSourceSelfEmployed',
    subtext: 'Includes gig workers and 1099 recipients',
    value: 'self_employed'
  },
  {
    displayValue: 'Other Taxable Income',
    id: 'primaryIncomeSourceOtherTaxableIncome',
    subtext: 'Includes social security, disability, and retirement',
    value: 'other_taxable_income'
  },
  {
    displayValue: 'Other Non-Taxable Income',
    id: 'primaryIncomeSourceOtherNontaxableIncome',
    subtext: "Includes veterans' disability, wellfare, or insurance proceeds",
    value: 'other_non_taxable_income'
  }
];

export const LENGTH_OF_INCOME_OPTIONS = [
  {
    displayValue: 'Less than a month',
    id: 'lengthOfReceivingIncome0',
    value: '0'
  },
  {
    displayValue: '1 to 5 months',
    id: 'lengthOfReceivingIncome3',
    value: '3'
  },
  {
    displayValue: '6 to 11 months',
    id: 'lengthOfReceivingIncome9',
    value: '9'
  },
  {
    displayValue: '1 to 4 years',
    id: 'lengthOfReceivingIncome24',
    value: '24'
  },
  {
    displayValue: 'More than 4 years',
    id: 'lengthOfReceivingIncome60',
    value: '60'
  }
];

export const BLANK_BANK_INFO = {
  newAccountType: '',
  newRoutingNumber: '',
  newBankName: '',
  newAccountNumber: '',
  newConfirmAccountNumber: '',
  newBankAccountAge: ''
};
